import React, { useEffect, useRef, useState } from "react";
import { FaKey } from "react-icons/fa";
import { getStripeKeys, updateKeys } from "../../../../redux/slices/keySlice";
import { useDispatch, useSelector } from "react-redux";

const StripeKeys = () => {
  const [keys, setKeys] = useState({
    pkliveKey: "",
    skliveKey: "",
  });

  const [originalKeys, setOriginalKeys] = useState({
    pkliveKey: "",
    skliveKey: "",
  });

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { stripeKeys, refetch } = useSelector((state) => state.keySlice);
  const prevProps = useRef({ refetch }).current;

  useEffect(() => {
    if (prevProps.refetch != refetch) {
      dispatch(getStripeKeys(setLoading));
    }
    return () => {
      prevProps.refetch = refetch;
    };
  }, [refetch]);

  useEffect(() => {
    dispatch(getStripeKeys(setLoading));
  }, []);

  const handleChange = (e) => {
    setKeys({ ...keys, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    if (stripeKeys) {
      const updated = {
        pkliveKey: stripeKeys.pkliveKey,
        skliveKey: stripeKeys.skliveKey,
      };
      setKeys(updated);
      setOriginalKeys(updated);
    }
  }, [stripeKeys]);

  const handleSave = () => {
    dispatch(updateKeys(stripeKeys._id, keys, setLoading));
  };

  const isChanged =
    keys.pkliveKey !== originalKeys.pkliveKey ||
    keys.skliveKey !== originalKeys.skliveKey;

  return (
    <div className="container-fluid px-4 py-4">
      <div className="card shadow border-0 w-100">
        {/* Header */}
        <div
          className="card-header d-flex align-items-center gap-2"
          style={{
            backgroundColor: "#f6d25a",
            borderBottom: "none",
            padding: "20px 30px",
          }}
        >
          <FaKey size={24} className="text-dark" />
          <h4 className="m-0 fw-bold text-dark">Stripe Keys</h4>
        </div>

        {/* Body */}
        <div className="card-body px-4 py-4">
          <form className="w-100">
            {/* PK Live */}
            <div className="mb-4">
              <label className="form-label fw-semibold fs-5">
                Publishable Key (PK Live)
              </label>
              <input
                type="text"
                className="form-control form-control-lg"
                name="pkliveKey"
                value={keys.pkliveKey}
                onChange={handleChange}
                placeholder="Enter PK Live Key"
                style={{ padding: "14px" }}
              />
            </div>

            {/* SK Live */}
            <div className="mb-4">
              <label className="form-label fw-semibold fs-5">
                Secret Key (SK Live)
              </label>
              <input
                type="text"
                className="form-control form-control-lg"
                name="skliveKey"
                value={keys.skliveKey}
                onChange={handleChange}
                placeholder="Enter SK Live Key"
                style={{ padding: "14px" }}
              />
            </div>

            {/* Save Button */}
            <div className="d-flex justify-content-center mt-3">
              <button
                type="button"
                onClick={handleSave}
                disabled={!isChanged}
                className="btn py-3 px-5 fs-5 fw-bold"
                style={{
                  backgroundColor: isChanged ? "#f6c842" : "#d9d9d9",
                  border: "none",
                  letterSpacing: "0.5px",
                  cursor: isChanged ? "pointer" : "not-allowed",
                  minWidth: "200px",
                  transition: "0.3s",
                }}
              >
                Save Keys
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default StripeKeys;
